import { PORTAL_HEADER } from './storage';

export const EMPTY_QUEUE = {
  items: [],
  active_count: 0,
  in_service_count: 0,
  completed_count: 0,
};

export function checkinQueueAuthHeaders(portalId, token, extra = {}) {
  const headers = { ...extra };
  if (portalId) headers[PORTAL_HEADER] = portalId;
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}

export function checkinQueueFetchInit(portalId, token, extra = {}) {
  const { headers: extraHeaders, ...rest } = extra;
  return {
    credentials: 'include',
    ...rest,
    headers: checkinQueueAuthHeaders(portalId, token, extraHeaders || {}),
  };
}
